import request from "../utils/fetch";
export function getAllOrder(data) {
  return request({
    url: "/activitySignup/getAllOrder",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
export function getAll(data) {
  return request({
    url: "/paradiseSignup/getAll",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
export function getStoreOrderList(data) {
  return request({
    url: "/admin/orders/getStoreOrderList",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
export function getOrderInfo(data) {
  return request({
    url: "/admin/orders/getOrderInfo",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}
export function expressInfo(data) {
  return request({
    url: "/wxmapp/expressInfo",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 订单列表
export function orderList(data) {
  return request({
    url:
      "/order/equipment/order/enterprise/list?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function orderList_ro(data) {
  return request({
    url:
      "/order-ro/equipment/order/enterprise/list?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 订单数据
export function orderData(data) {
  return request({
    url: "/order/enterprise/statistics/get/all",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function topOrderList(data) {
  return request({
    url:
      "/order/water/ticket/order/enterprise/list?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function topOrderStat(data) {
  return request({
    url: "/order/enterprise/statistics/get/all",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

export function topOrderStatNew(data) {
  return request({
    url: "/order/water/ticket/order/enterprise/enterprise/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function orderListStatNew(data) {
  return request({
    url: "/order/equipment/order/enterprise/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function orderListStatNew_ro(data) {
  return request({
    url: "/order-ro/equipment/order/enterprise/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

export function orderDataAllNew(data) {
  return request({
    url: "/order/equipment/order/enterprise/statistics",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 运营数据统计
export function yunyingData(data) {
  return request({
    url: "/order/equipment/statistics/get/group/by/all",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 售后退款列表
export function tuikuanList(data) {
  return request({
    url:
      "/order/water/ticket/order/refund/list?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 复审
export function fushen(data) {
  return request({
    url: "/order/water/ticket/order/refund/examine/answer",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 上传凭证
export function exportPinzheng(data) {
  return request({
    url: "/order/water/ticket/order/refund/payment/answer",
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
  });
}

// 退款统计
export function tuikuanState(data) {
  return request({
    url: "/order/water/ticket/order/refund/statistics",
    method: "post",
    requestBody: "body",
    loading: false,
    data: data,
  });
}

// 订单详情
export function orderDetails(data) {
  return request({
    url: "/order/admin/equipment/order/get/info",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 设备查询水量类型
export function equipmentQuery(data) {
  return request({
    url: "/equipment/pc/getdeviceInfo",
    method: "get",
    requestBody: "query",
    loading: true,
    params: data,
  });
}

// 消费订单导出
export function xiaofeiExport(data) {
  return request({
    url:
      "/order/equipment/order/enterprise/export?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 消费订单导出查询条数
export function xiaofeiExportNum(data) {
  return request({
    url:
      "/order/equipment/order/enterprise/export?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    // header: {
    //   headers: { "Content-Type": "application/x-download" },
    // },
    // responseType: "blob",
  });
}

// 充值订单导出
export function topExport(data) {
  return request({
    url:
      "/order/water/ticket/order/enterprise/enterprise/export?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    header: {
      headers: { "Content-Type": "application/x-download" },
    },
    responseType: "blob",
  });
}

// 充值订单导出数量
export function topExportNum(data) {
  return request({
    url:
      "/order/water/ticket/order/enterprise/enterprise/export?pageNum=" +
      data.pageNum +
      "&pageSize=" +
      data.pageSize,
    method: "post",
    requestBody: "body",
    loading: true,
    data: data,
    // header: {
    //   headers: { "Content-Type": "application/x-download" },
    // },
    // responseType: "blob",
  });
}
